import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";

import { Opening } from "../../page/Grey/Opening/Opening";
import { Balance } from "../../page/Grey/Balance/Balance";
import { Delivery } from "../../page/Grey/Delivery/Delivery";
import Dashboard from "../../page/Grey/Dashboard/Dashboard";
import { GreyInwardReport } from "../../page/Grey/Grey Inward Report/GreyInwardReport";
import { MonthWiseInOut } from "../../page/Grey/Month Wise In Out/MonthWiseInOut";
import { PartyWiseInOut } from "../../page/Grey/Party Wise In Out/PartyWiseInOut";
import { PartyProfile } from "../../page/Grey/Party Profile/PartyProfile";
import { ProductiongroupInOut } from "../../page/Grey/Production Group In Out/ProductionGroupInOut";
import { QualityWiseInOut } from "../../page/Grey/Quality Wise In Out/QualityWiseInOut";
import { TotalBalanceMeter } from "../../page/Grey/Total Balance Meter/TotalBalanceMeter";
import { Daywise } from "../../page/Grey/Daywise/Daywise";
import { Inward } from "../../page/Grey/Inward/Inward";
import OrderApproval from "../../page/OrderApproval/OrderApproval";

import { Ledger } from "../../page/FAS/FINANCIAL STATEMENT/LEDGER/Ledger";
import { TrialBalance } from "../../page/FAS/FINANCIAL STATEMENT/TRIAL BALANCE/TrialBalance";
import { ProfitAndLoss } from "../../page/FAS/FINANCIAL STATEMENT/PROFIT AND LOSS/ProfitAndLoss";
import { BalanceSheet } from "../../page/FAS/FINANCIAL STATEMENT/BALANCE SHEET/BalanceSheet";
import { FundAndFlow } from "../../page/FAS/FINANCIAL STATEMENT/FUND FLOW/FundAndFlow";
import { Receivable } from "../../page/FAS/OUTSTANDING REPORT/RECEIVABLE/Receivable";
import { Payable } from "../../page/FAS/OUTSTANDING REPORT/PAYABLE/Payable";
import { Customer } from "../../page/FAS/PROFILE ANAYLYSIS/CUSTOMER/Customer";
import { Supplier } from "../../page/FAS/PROFILE ANAYLYSIS/SUPPLIER/Supplier";
import { Bank } from "../../page/FAS/DAYBOOK ANALYSIS/BANK/Bank";
import { SaleDashboard } from "../../page/FAS/DAYBOOK ANALYSIS/SALES/SaleDashBoard/SaleDashboard";
import { MonthWisePartyWiseSale } from "../../page/FAS/DAYBOOK ANALYSIS/SALES/MonthWisePartyWise/MonthWisePartyWiseSale";
import { PartyWiseItemWiseSale } from "../../page/FAS/DAYBOOK ANALYSIS/SALES/PartyWiseItemWise/PartyWiseItemWiseSale";
import { ProductionGroupWise } from "../../page/FAS/DAYBOOK ANALYSIS/SALES/ProductionGroupWise/ProductionGroupWise";
import { ItemWiseMonthWise } from "../../page/FAS/DAYBOOK ANALYSIS/SALES/ItemWiseMonthWise/ItemWiseMonthWise";
import { ItemWiseSummary } from "../../page/FAS/DAYBOOK ANALYSIS/SALES/ItemWiseSummary/ItemWiseSummary";
import { PartyItemWiseSummary } from "../../page/FAS/DAYBOOK ANALYSIS/SALES/PartyItemWiseSummary/PartyItemWiseSummary";
import { MonthItemParty } from "../../page/FAS/DAYBOOK ANALYSIS/SALES/MonthItemParty/MonthItemParty";
import { PartyWiseQuater } from "../../page/FAS/DAYBOOK ANALYSIS/SALES/PartyWiseQuarter/PartyWiseQuarter";
import { PurchasheDashboard } from "../../page/FAS/DAYBOOK ANALYSIS/PURCHASE/PurchaseDashboard/PurchasheDashboard";
import { MonthWisePartyWisePurchase } from "../../page/FAS/DAYBOOK ANALYSIS/PURCHASE/MonthWisePartyWisePurchase/MonthWisePartyWisePurchase";
import { PartyWiseItemWisePurchase } from "../../page/FAS/DAYBOOK ANALYSIS/PURCHASE/PartyWiseItemWisePurchase/PartyWiseItemWisePurchase";
import { MonthWiseBookWise } from "../../page/FAS/DAYBOOK ANALYSIS/PURCHASE/MonthWiseBookWise/MonthWiseBookWise";
import { BookWise } from "../../page/FAS/DAYBOOK ANALYSIS/PURCHASE/BookWise/BookWise";
import { BookWiseSubBookWise } from "../../page/FAS/DAYBOOK ANALYSIS/PURCHASE/BookWiseSubBookWise/BookWiseSubBookWise";
import { BookWiseMonthlyAnylysis } from "../../page/FAS/DAYBOOK ANALYSIS/PURCHASE/BookWiseMonthlyAnylysis/BookWiseMonthlyAnylysis";
import { Gstr } from "../../page/FAS/STATUTORY REPORT/GSTR/Gstr";
import { Tds } from "../../page/FAS/STATUTORY REPORT/TDS/Tds";

import { SalaryAnalysisDashboard } from "../../page/PayRoll/Salary Analysis Dashboard/SalaryAnalysisDashboard";
import { SalaryStateMent } from "../../page/PayRoll/Salary Statement/SalaryStatement";
import { DepWiseSalarySummary } from "../../page/PayRoll/Dep Wise Salary Summary/DepWiseSalarySummary";
import { EmployeeProfile } from "../../page/PayRoll/Employee Profile/EmployeeProfile";
import { SalarySummary } from "../../page/PayRoll/Salary Summary/SalarySummary";
import { PTStatement } from "../../page/PayRoll/PT Statement/PTStatement";
import { ESIStatement } from "../../page/PayRoll/ESI Statement/ESIStatement";
import { PFStatement } from "../../page/PayRoll/PF Statement/PFStatement";
import { ESI_PF_PT_Summary } from "../../page/PayRoll/ESI PF PT Summary/ESI_PF_PT_Summary";
import { DepartmentWisePresent } from "../../page/PayRoll/DepartmentWise Present/DepartmentWisePresent";

import { MachineGroupWiseCosting } from "../../page/Colour/Consumption/Machine GroupWise Costing/MachineGroupWiseCosting";
import { MasterWiseMachineGroupCosting } from "../../page/Colour/Consumption/MasterWise Machine Group Costing/MasterWiseMachineGroupCosting";
import { InwardAnalysis } from "../../page/Colour/Inward/Inward Analysis/InwardAnalysis";
import MachineGroupMachineCosting from "../../page/Colour/Consumption/Machine Group With Machine Costing/MachineGroupMachineCosting";
import { MachineGroupCostingSummary } from "../../page/Colour/Consumption/Machine Group Costing Summary/MachineGroupCostingSummary";
import { MasterWiseMonthlyConsumption } from "../../page/Colour/Consumption/MasterWise Monthly Consumption/MasterWiseMonthlyConsumption";
import { MachineGroupCostingAnalysis } from "../../page/Colour/Consumption/Machine Group Costing Analysis/MachineGroupCostingAnalysis";
import { MachineGroupBatchCosting } from "../../page/Colour/Consumption/Machine Group Batch Costing/MachineGroupBatchCosting";
import { MasterWiseConsumption } from "../../page/Colour/Consumption/MasterWise Consumption/MasterWiseConsumption";
import { MasterWiseCosting } from "../../page/Colour/Consumption/MasterWise Costing/MasterWiseCosting";
import { Abc } from "../../page/Colour/Analysis/ABC/Abc";
import { Fsn } from "../../page/Colour/Analysis/FSN/Fsn";
import { Stock } from "../../page/Colour/Analysis/Stock/Stock";
import { MonthlyStockPage } from "../../page/Colour/Analysis/Monthly Stock/MonthlyStock";
import { Item_supplierAnalysis } from "../../page/Colour/Analysis/Item_Supplier Analysis/Item_supplierAnalysis";
import { Party_ItemAnalysis } from "../../page/Colour/Analysis/Party_Item Analysis/Party_ItemAnalysis";

import { InwardAnalysism } from "../../page/Maintenance/Inward/Inward Analysis/InwardAnalysism";
import { InwardItemWise } from "../../page/Maintenance/Inward/Inward ItemWise/InwardItemWise";
import { IssuseItemWIse } from "../../page/Maintenance/Consumption/Issuse ItemWise/IssuseItemWIse";
import { ItemWiseMachineConsuption } from "../../page/Maintenance/Consumption/ItemWise Machine Consumption/itemWiseMachineConsuption";
import { MachineGroupMonthWiseConsumption } from "../../page/Maintenance/Consumption/Machine Group MonthWise Consumption/MachineGroupMonthWiseConsumpton";
import { MachineWiseConsumption } from "../../page/Maintenance/Consumption/MachineWise Consumption/MachineWiseConsumption";
import { ItemWiseDailyAndMonthly } from "../../page/Maintenance/Consumption/ItemWise Daily And Monthly/itemWiseDailyAndMonthly";
import { MachineGroupWiseConsumption } from "../../page/Maintenance/Consumption/Machine GroupWise Consumption/machineGroupWiseConsumption";
import { FsnAnalysis } from "../../page/Maintenance/Anlysis/FSN Analysis/FsnAnalysis";
import { StaockAnalysis } from "../../page/Maintenance/Anlysis/Stock Analysis/StaockAnalysis";
import { AbcAnalysis } from "../../page/Maintenance/Anlysis/ABC Analysis/AbcAnalysis";
import { PartyItemAnalysis } from "../../page/Maintenance/Anlysis/Party item Analysis/PartyItemAnalysis";
import {
  ItemSupllierAnalysis,
  ItemSupllierAnalysisM,
} from "../../page/Maintenance/Anlysis/Item Supplier Analysis/ItemSupllierAnalysis";

import { StagewiseInOutBalance } from "../../page/Millstage/Stagewise InOut Balance/StagewiseInOutBalance";
import { LootWiseReport } from "../../page/Millstage/Lootewise Report/LootWiseReport";
import { GroupWiseStageWiseBalance } from "../../page/Millstage/GroupWise & StageWise Balance/GroupWiseStageWiseBalance";
import { GroupWiseStageDetailReport } from "../../page/Millstage/GroupWise StageDetail Report/GroupWiseStageDetailReport";
import { GroupWisePartyWiseDetailReport } from "../../page/Millstage/GroupWise PartyWise Detail Report/GroupWisePartyWiseDetailReport";
import { MachineWiseBatchDetail } from "../../page/Millstage/MachineWise Batch Detail/MachineWiseBatchDetail";
import GreystageBalance from "../../page/Millstage/GreyStage Balance/GreyStageBalance";
import ProcessMaster from "../../page/MillstageEntry/ProcessMaster/ProcessMaster";
import Demo from "../../page/Grey/Demo/Demo";
import UserRight from "../../page/UserRight/UserRight";
import CollectionMan from "../../page/CollectionMan/CollectionMan";
import OberallDashBoard from "../../page/OVERALL DASHBOARD/OberallDashBoard";
import { NotFound } from "../../page/NotFound/NotFound";
import ProcessQuality from "../../page/MillstageEntry/ProcessQuality/ProcessQuality";
import SubProcess from "../../page/MillstageEntry/SubProcess/SubProcess";
import ShadeMaster from "../../page/MillstageEntry/ShadeMaster/ShadeMaster";
import QualityMaster from "../../page/MillstageEntry/QualityMaster/QualityMaster";
import TransProcessType from "../../page/MillstageEntry/TransProcessType/TransProcessType";
import RecipeMaster from "../../page/MillstageEntry/RecipeMaster/RecipeMaster";
import RecipeMasterList from "../../page/MillstageEntry/RecipeMasterList/RecipeMasterList";
import ProdConsRecipe from "../../page/MillstageEntry/ProdConsRecipe/ProdConsRecipe";
import ProdConsRecipeList from "../../page/MillstageEntry/ProdConsRecipeList/ProdConsRecipeList";
import Treatment from "../../page/MillstageEntry/Treatment/Treatment";
import TreatmentList from "../../page/MillstageEntry/TreatmentList/TreatmentList";
import LotPositioin from "../../page/MillstageEntry/LotPositioin/LotPositioin";
import LotEntry from "../../page/MillstageEntry/LotEntry/LotEntry";

function AllRoute({ theme }) {
  const { FilterProjectdata } = useSelector((state) => state.ClientLogin || {});
  const role = Cookies.get("Role");
  const isCollectionMan = role?.toLowerCase() === "collection man";
  const isMillStageUser = role?.toLowerCase() === "millstageuser";

  const isProjectAllowed = (projectName) => {

    if (!FilterProjectdata?.Project_list) return false;

    const projectMapping = {
      "MILL STAGE": "MILLSTAGE",
      MILLSTAGE: "MILLSTAGE",
      STORE: "MAINTENANCE",
      MAINTENANCE: "MAINTENANCE",
      GREY: "GREY",
      FAS: "FAS",
      PAYROLL: "PAYROLL",
      COLOUR: "COLOUR",
      "ORDER APPROVAL": "ORDER APPROVAL",
      ORDERAPPROVAL: "ORDER APPROVAL",
      "COLLECTION MAN": "COLLECTION MAN",

    };

    return FilterProjectdata.Project_list.some((item) => {
      const dbProjName = item.DashboardProjectName?.toUpperCase();
      const mappedName = projectMapping[dbProjName] || dbProjName;
      return mappedName === projectName?.toUpperCase();
    });

  };

  const isUserRightsAllowed = role !== "User" && role !== "Collection Man";

  return (
    <Routes>
      {/* Root route with dynamic redirect based on allowed projects */}
      <Route
        path="/"
        element={
          isCollectionMan ? (
            <Navigate to="/CollectionMan" replace />
          ) : isMillStageUser ? (
            <Navigate to="/GreyStageBalance" replace />
          ) : isProjectAllowed("GREY") ? (
            <Dashboard theme={theme} />
          ) : isProjectAllowed("COLLECTION MAN") ? (
            <Navigate to="/CollectionMan" replace />
          ) : isProjectAllowed("FAS") ? (
            <Navigate to="/Ledger" replace />
          ) : isProjectAllowed("PAYROLL") ? (
            <Navigate to="/SalaryAnalysisDashboard" replace />
          ) : isProjectAllowed("COLOUR") ? (
            <Navigate to="/InwardAnalysis" replace />
          ) : isProjectAllowed("MAINTENANCE") ? (
            <Navigate to="/InwardAnalysism" replace />
          ) : isProjectAllowed("MILLSTAGE") ? (
            <Navigate to="/GreyStageBalance" replace />
          ) : isProjectAllowed("ORDER APPROVAL") ? (
            <Navigate to="/OrderApproval" replace />
          ) : /* Loading or fallback if project list not loaded yet */
            FilterProjectdata?.Project_list ? (
              <div
                style={{ padding: "40px", textAlign: "center", color: "#64748b" }}
              >
                <h3>No authorized modules found</h3>
                <p>Please contact your administrator to assign project rights.</p>
              </div>
            ) : (
              <div
                style={{ padding: "40px", textAlign: "center", color: "#64748b" }}
              >
                <h3>Loading your permissions...</h3>
              </div>
            )
        }
      />

      <Route path="/OberallDashBoard" element={<OberallDashBoard />} />
      <Route path="/OverallDashboard" element={<OberallDashBoard />} />

      {/* ---------------GREY-------------- */}
      {isProjectAllowed("GREY") && (
        <>
          {/* <Route path="/" element={<OberallDashBoard />} /> */}
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/Opening" element={<Opening />} />
          <Route path="/Balance" element={<Balance />} />
          <Route path="/Delivery" element={<Delivery />} />
          <Route path="/Inward" element={<Inward />} />
          <Route path="/GreyInwardReport" element={<GreyInwardReport />} />
          <Route path="/MonthWiseInOut" element={<MonthWiseInOut />} />
          <Route path="/PartyWiseInOut" element={<PartyWiseInOut />} />
          <Route path="/PartyProfile" element={<PartyProfile />} />
          <Route
            path="/ProductiongroupInOut"
            element={<ProductiongroupInOut />}
          />
          <Route path="/QualityWiseInOut" element={<QualityWiseInOut />} />
          <Route path="/TotalBalanceMeter" element={<TotalBalanceMeter />} />
          <Route path="/Daywise" element={<Daywise />} />
          <Route path="/Demo" element={<Demo />} />

        </>
      )}

      {/* ---------------FAS-------------- */}
      {isProjectAllowed("FAS") && (
        <>
          <Route path="/Ledger" element={<Ledger />} />
          <Route path="/TrialBalance" element={<TrialBalance />} />
          <Route path="/ProfitAndLoss" element={<ProfitAndLoss />} />
          <Route path="/BalanceSheet" element={<BalanceSheet />} />
          <Route path="/FundAndFlow" element={<FundAndFlow />} />
          <Route path="/Receivable" element={<Receivable />} />
          <Route path="/Payable" element={<Payable />} />
          <Route path="/Customer" element={<Customer />} />
          <Route path="/Supplier" element={<Supplier />} />
          <Route path="/Bank" element={<Bank />} />
          <Route path="/SaleDashboard" element={<SaleDashboard />} />
          <Route
            path="/MonthWisePartyWiseSale"
            element={<MonthWisePartyWiseSale />}
          />
          <Route
            path="/PartyWiseItemWiseSale"
            element={<PartyWiseItemWiseSale />}
          />
          <Route
            path="/ProductionGroupWise"
            element={<ProductionGroupWise />}
          />
          <Route path="/ItemWiseMonthWise" element={<ItemWiseMonthWise />} />
          <Route path="/ItemWiseSummary" element={<ItemWiseSummary />} />
          <Route
            path="/PartyItemWiseSummary"
            element={<PartyItemWiseSummary />}
          />
          <Route path="/MonthItemParty" element={<MonthItemParty />} />
          <Route path="/PartyWiseQuarter" element={<PartyWiseQuater />} />
          <Route path="/PurchaseDashboard" element={<PurchasheDashboard />} />
          <Route
            path="/MonthWisePartyWisePurchase"
            element={<MonthWisePartyWisePurchase />}
          />
          <Route
            path="/PartyWiseItemWisePurchase"
            element={<PartyWiseItemWisePurchase />}
          />
          <Route path="/MonthWiseBookWise" element={<MonthWiseBookWise />} />
          <Route path="/BookWise" element={<BookWise />} />
          <Route
            path="/BookWiseSubBookWise"
            element={<BookWiseSubBookWise />}
          />
          <Route
            path="/BookWiseMonthlyAnylysis"
            element={<BookWiseMonthlyAnylysis />}
          />
          <Route path="/Gstr" element={<Gstr />} />
          <Route path="/Tds" element={<Tds />} />
        </>
      )}

      {/* ---------------PAYROLL-------------- */}
      {isProjectAllowed("PAYROLL") && (
        <>
          <Route
            path="/SalaryAnalysisDashboard"
            element={<SalaryAnalysisDashboard />}
          />
          <Route path="/SalaryStatement" element={<SalaryStateMent />} />
          <Route
            path="/DepWiseSalarySummary"
            element={<DepWiseSalarySummary />}
          />
          <Route path="/EmployeeProfile" element={<EmployeeProfile />} />
          <Route path="/SalarySummary" element={<SalarySummary />} />
          <Route path="/PTStatement" element={<PTStatement />} />
          <Route path="/ESIStatement" element={<ESIStatement />} />
          <Route path="/PFStatement" element={<PFStatement />} />
          <Route path="/ESI_PF_PT_Summary" element={<ESI_PF_PT_Summary />} />
          <Route
            path="/DepartmentWisePresent"
            element={<DepartmentWisePresent />}
          />
        </>
      )}

      {/* ---------------COLOUR-------------- */}
      {isProjectAllowed("COLOUR") && (
        <>
          <Route path="/InwardAnalysis" element={<InwardAnalysis />} />
          <Route
            path="/MachineGroupWiseCosting"
            element={<MachineGroupWiseCosting />}
          />
          <Route
            path="/MasterWiseMachineGroupCosting"
            element={<MasterWiseMachineGroupCosting />}
          />
          <Route
            path="/MachineGroupWithMachineCosting"
            element={<MachineGroupMachineCosting />}
          />
          <Route
            path="/MachineGroupCostingSummary"
            element={<MachineGroupCostingSummary />}
          />
          <Route
            path="/MasterWiseMonthlyConsumption"
            element={<MasterWiseMonthlyConsumption />}
          />
          <Route
            path="/MachineGroupCostAnlysis"
            element={<MachineGroupCostingAnalysis />}
          />
          <Route
            path="/MachineGroupBatchCosting"
            element={<MachineGroupBatchCosting />}
          />
          <Route
            path="/MasterWiseConsumption"
            element={<MasterWiseConsumption />}
          />
          <Route path="/MasterWiseCosting" element={<MasterWiseCosting />} />
          <Route path="/Abc" element={<Abc />} />
          <Route path="/Fsn" element={<Fsn />} />
          <Route path="/Stock" element={<Stock />} />
          <Route path="/MonthlyStock" element={<MonthlyStockPage />} />
          <Route
            path="/ItemSupplierAnaylysis"
            element={<Item_supplierAnalysis />}
          />
          <Route path="/PartyItemAnalysis" element={<Party_ItemAnalysis />} />
        </>
      )}

      {/* ---------------MAINTENANCE-------------- */}
      {isProjectAllowed("MAINTENANCE") && (
        <>
          <Route path="InwardAnalysism" element={<InwardAnalysism />} />
          <Route path="InwardItemWise" element={<InwardItemWise />} />
          <Route path="IssueItemWise" element={<IssuseItemWIse />} />
          <Route
            path="ItemWiseMachineWiseConsumption"
            element={<ItemWiseMachineConsuption />}
          />
          <Route
            path="MachineMachineGroupWiseConsumtion"
            element={<MachineGroupMonthWiseConsumption />}
          />
          <Route
            path="MachineWiseConsumption"
            element={<MachineWiseConsumption />}
          />
          <Route
            path="MachineGroupWiseConsumtion"
            element={<MachineGroupWiseConsumption />}
          />
          <Route
            path="MachineGroupMonthWiseConsumption"
            element={<MachineGroupMonthWiseConsumption />}
          />
          <Route
            path="itemWiseDailyAndMonthly"
            element={<ItemWiseDailyAndMonthly />}
          />
          <Route path="FsnAnalysis" element={<FsnAnalysis />} />
          <Route path="StockAnalysis" element={<StaockAnalysis />} />
          <Route path="AbcAnalysis" element={<AbcAnalysis />} />
          <Route path="PartyItemAnalysisMain" element={<PartyItemAnalysis />} />
          <Route
            path="ItemSupplierAnaylysisMain"
            element={<ItemSupllierAnalysis />}
          />
        </>
      )}

      {/* ---------------MILLSTAGE-------------- */}
      {isProjectAllowed("MILLSTAGE") && (
        <>
          <Route path="/GreyStageBalance" element={<GreystageBalance />} />
          <Route
            path="/StageWiseInOutBalance"
            element={<StagewiseInOutBalance />}
          />
          <Route path="/LootWiseReport" element={<LootWiseReport />} />
          <Route
            path="/GroupWiseStageWiseBalance"
            element={<GroupWiseStageWiseBalance />}
          />
          <Route
            path="/GroupWiseStageDetailReport"
            element={<GroupWiseStageDetailReport />}
          />
          <Route
            path="/GroupWisePartyWiseDetailReport"
            element={<GroupWisePartyWiseDetailReport />}
          />
          <Route
            path="/MachineWiseBatchDetail"
            element={<MachineWiseBatchDetail />}
          />
        </>
      )}

      {/* ---------------MILLSTAGE ENTRY-------------- */}
      {isProjectAllowed("MILLSTAGE ENTRY") && (
        <>
          <Route path="/ProcessMaster" element={<ProcessMaster />} />
          <Route path="/ProcessQuality" element={<ProcessQuality />} />
          <Route path="/SubProcess" element={<SubProcess />} />
          <Route path="/ShadeMaster" element={<ShadeMaster />} />
          <Route path="/QualityMaster" element={<QualityMaster />} />
          <Route path="/TransProcessType" element={<TransProcessType />} />
          <Route path="/RecipeMaster" element={<RecipeMaster />} />
          <Route path="/RecipeMasterList" element={<RecipeMasterList />} />
          <Route path="/ProdConsRecipe" element={<ProdConsRecipe />} />
          <Route path="/ProdConsRecipeList" element={<ProdConsRecipeList />} />
          <Route path="/Treatment" element={<Treatment />} />
          <Route path="/TreatmentList" element={<TreatmentList />} />
          <Route path="/LotPositioin" element={<LotPositioin />} />
          <Route path="/LotEntry" element={<LotEntry />} />
        </>
      )}

      {/* --------------- ORDER APPROVAL -------------- */}
      {isProjectAllowed("ORDER APPROVAL") && (
        <Route path="/OrderApproval" element={<OrderApproval />} />
      )}

      {/* --------------- COLLECTION MAN -------------- */}
      {(isCollectionMan || isProjectAllowed("COLLECTION MAN")) && (
        <Route path="/CollectionMan" element={<CollectionMan />} />
      )}

      {/* --------------- USER RIGHTS (Role Guarded) -------------- */}
      {isUserRightsAllowed && (
        <Route path="/UserRight" element={<UserRight />} />
      )}

      {/* Fallback Catch-all Wildcard Route to prevent accessing missing/unauthorized paths */}
      {FilterProjectdata?.Project_list && (
        <Route
          path="*"
          element={<NotFound />}
        />
      )}
    </Routes>
  );
}

export default AllRoute;
